import React from "react";
import "./Loader2.scss";

const Loader2 = () => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        gap: "40px",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div>
        <div className="loader2"></div>
      </div>
      <div style={{ color: "#ffffff", fontWeight: "bold" }}>Please wait...</div>
    </div>
  );
};

export default Loader2;
